module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vc3R5bGUvX2NvbG9ycyc7CkBpbXBvcnQgJy4uL3N0eWxlL19sYXlvdXQnOwoKLkJhY2tncm91bmQgewogIGJvcmRlci10b3A6IDNweCBkYXNoZWQgJHNlY29uZGFyeTsKICBtYXgtd2lkdGg6ICRtYXhXaWR0aENvbnRhaW5lcjsKICBwYWRkaW5nLXRvcDogNDBweDsKICBtYXJnaW46IC00MHB4IGF1dG8gYXV0byBhdXRvOwoKICBzdHJvbmcgewogICAgYmFja2dyb3VuZC1jb2xvcjogJHByaW1hcnk7CiAgICBwYWRkaW5nOiAwIDEwcHg7CiAgICBjb2xvcjogI2ZmZjsKICB9Cn0K"


//////////////////
// WEBPACK FOOTER
// ./src/components/Background.scss
// module id = 642
// module chunks = 0